function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(1, 1)",
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  d: "M840.4 918h-674c-32.6 0-62.6-12.6-84.6-35.6-20.1-20.9-31.7-48.7-33.2-78.8-.8-3.9-1.1-8.2-.6-13.2.3-3.6.9-8 1.9-13.4 2-10.8 5.3-25.3 9.7-41.9l74-301 .1-.3C148 378.9 195.4 342 251.4 342h54.2c-5.1-20.9-5.6-37.4-5.2-49.8.7-55 21.5-105.9 58.7-143.3C396.7 110.9 448 90 503.4 90c55.4 0 106.6 20.9 144.3 58.9 37.2 37.5 58 88.4 58.7 143.4.5 18.2-1.7 34.9-5.2 49.7h54.2c56 0 103.4 36.9 117.8 91.8l.1.5 75.1 301.4c4 16.8 7 31.3 8.8 41.9.9 5.4 1.5 9.7 1.7 13.2.4 4.8.1 9-.7 12.8-1.5 30.1-13.2 57.8-33.2 78.8-22 23-52.1 35.6-84.6 35.6zm-720-126.6v5.6c0 28.4 19.3 49 46 49h674c26.7 0 46-20.6 46-49v-6.3c-1-6.5-3.4-18.7-8-38.2L803.5 452c-6.2-23.4-24.7-38-48.1-38H591.1l26-52.1c12.8-25.5 17.9-45.8 17.2-67.8v-.7c-.4-36.3-13.8-69.6-37.8-93.8-24-24.2-57.1-37.6-93.2-37.6-36 0-69.1 13.4-93.2 37.6-24 24.2-37.4 57.5-37.8 93.8v.7c-.7 22 4.5 42.3 17.2 67.8l26.1 52.1H251.4c-23.4 0-41.9 14.5-48.1 37.9l-74 301-.1.3c-5.1 19.5-7.7 31.8-8.8 38.2z",
  vectorEffect: "non-scaling-stroke"
}), /*#__PURE__*/React.createElement("path", {
  d: "M503.4 230.1c-36.8 0-65.1 27.4-65.1 64.3 0 37.6 28.2 66.6 65.1 66.6s65.1-29 65.1-66.6c0-36.9-28.3-64.3-65.1-64.3z"
}));

function SvgWeight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    overflow: "visible",
    preserveAspectRatio: "none",
    viewBox: "0 0 1010 1010",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeight);
export default __webpack_public_path__ + "static/media/weight.545d09ec.svg";
export { ForwardRef as ReactComponent };